import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class VersionService {
	constructor(private http: HttpClient) {
	}

	getVersion(): Observable<{version?: string} | null> {
		return this.http.get<{version?: string}>('/assets/version.json').pipe(
			catchError(() => of(null)),
		);
	}
}
